import React from "react";

function RailSVG({ colorCode = "", seaClass = "" }) {
	return (
		<svg
			className={`MuiSvgIcon-root ${seaClass}`}
			viewBox="0 0 24 21">
			<path
				fill={colorCode}
				d="M21.442,1.345c0.054-0.213-0.134-0.453-0.347-0.453c-2.584,0-5.168,0-7.752,0
	c-0.213,0-0.373,0.187-0.373,0.399c0,0.187,0.187,0.347,0.373,0.32c0.559,0,1.092,0,1.651,0c0.56,0.56,1.119,1.119,1.705,1.705
	c-1.119,0-2.265,0-3.384,0c-0.426-0.027-0.852,0.133-1.199,0.426c-0.239,0.187-0.373,0.426-0.506,0.692
	C10.813,5.981,9.96,7.5,8.868,8.832C8.468,9.311,8.042,9.764,7.563,10.19c-0.4,0.346-0.826,0.666-1.306,0.905
	c-0.479,0.24-0.986,0.453-1.465,0.693c-1.226,0.533-2.478,1.012-3.756,1.412c-0.24,0.08-0.506,0.105-0.719,0.266
	c-0.16,0.107-0.293,0.267-0.293,0.453c0,0.826,0,1.679,0,2.504c0,0.214,0.08,0.427,0.24,0.561c0.106,0.105,0.266,0.133,0.426,0.133
	c6.394,0,12.761,0,19.155,0c0.586,0,1.172,0,1.732,0c0.559-0.187,1.092-0.479,1.518-0.906c0.48-0.453,0.773-1.092,0.88-1.731
	C24,14.187,24,13.92,24,13.627c0-1.385,0-2.771,0-4.156c0-0.906-0.053-1.838-0.24-2.718c-0.159-0.666-0.373-1.332-0.746-1.945
	c-0.318-0.533-0.799-1.012-1.385-1.279c-0.399-0.187-0.826-0.24-1.252-0.24c-0.799,0-1.625,0-2.425,0
	c0.56-0.56,1.119-1.119,1.679-1.678c0.479,0,0.986,0,1.465,0C21.256,1.612,21.416,1.505,21.442,1.345z M18.592,1.612
	c-0.426,0.426-0.853,0.853-1.279,1.279c-0.426-0.426-0.852-0.853-1.278-1.279C16.887,1.612,17.739,1.612,18.592,1.612z
	 M20.936,4.462c0.453,0,0.88,0.32,0.986,0.746c0.24,0.719,0.479,1.465,0.719,2.185c0.055,0.187,0.055,0.426-0.105,0.56
	c-0.134,0.133-0.347,0.133-0.533,0.133c-2.611,0-5.195,0-7.807,0c-0.159,0-0.346-0.026-0.479-0.133
	c-0.188-0.133-0.24-0.373-0.213-0.586c0.079-0.719,0.186-1.465,0.293-2.185c0.053-0.426,0.452-0.772,0.879-0.719
	C16.754,4.462,18.832,4.489,20.936,4.462z M10.253,8.352c0,0.32,0,0.639,0,0.986c-0.026,1.172-0.053,2.344-0.08,3.543
	c-0.426,0.4-0.959,0.693-1.465,0.959c0-0.319,0.026-0.666,0.026-0.985c0.027-0.347,0-0.72,0.027-1.065c0-0.293,0-0.56,0.026-0.853
	c0-0.267,0-0.56,0.027-0.826C9.294,9.551,9.8,8.965,10.253,8.352z M8.255,12.455c-0.026,0.319,0,0.666-0.026,0.985
	c0,0.187,0,0.373,0,0.56c0,0.053-0.054,0.053-0.08,0.053c-0.453,0.16-0.906,0.32-1.385,0.427c0.026-0.293,0-0.56,0.026-0.853
	c0.027-0.32,0-0.639,0.027-0.986c0-0.318,0-0.666,0.026-0.984c0.533-0.32,1.013-0.693,1.465-1.12
	C8.255,11.203,8.255,11.842,8.255,12.455z M21.762,11.416c0.453,0.106,0.8,0.479,0.854,0.932c0.053,0.453-0.188,0.906-0.587,1.119
	c-0.293,0.16-0.666,0.16-0.985,0.027c-0.293-0.134-0.506-0.4-0.613-0.693c-0.133-0.426,0.027-0.905,0.373-1.198
	C21.096,11.416,21.442,11.336,21.762,11.416z M14.516,11.416c0.373,0.08,0.693,0.373,0.799,0.746
	c0.107,0.319,0.054,0.692-0.133,0.959c-0.266,0.399-0.826,0.586-1.279,0.426c-0.319-0.106-0.586-0.373-0.692-0.692
	c-0.133-0.427,0-0.959,0.373-1.226C13.85,11.416,14.195,11.336,14.516,11.416z M6.257,14.64c-0.479,0.106-0.959,0.213-1.465,0.293
	c0-0.134,0-0.267,0-0.399c0.027-0.32,0-0.64,0.027-0.959c0-0.293,0-0.586,0.026-0.906c0.506-0.213,0.986-0.453,1.465-0.693
	C6.284,12.854,6.284,13.76,6.257,14.64z M4.365,12.881c0,0.72-0.026,1.439-0.026,2.131c-0.4,0.08-0.799,0.134-1.226,0.188
	c0-0.613,0.026-1.252,0.026-1.865C3.566,13.201,3.966,13.041,4.365,12.881z M2.66,13.521c0,0.532-0.026,1.039-0.026,1.571
	c0,0.054,0,0.134-0.027,0.188c-0.32,0.053-0.639,0.08-0.959,0.105c0-0.506,0.026-1.039,0.026-1.545
	C1.994,13.733,2.314,13.627,2.66,13.521z M1.195,14c0,0.133,0,0.267,0,0.426c0,0.347,0,0.666-0.026,1.013
	c-0.16,0.026-0.32,0.026-0.479,0.054c0-0.133,0-0.24,0-0.373c0.026-0.32,0-0.64,0.026-0.959C0.875,14.106,1.035,14.053,1.195,14z"
			/>
			<path
				fill={colorCode}
				d="M22.055,17.836c-0.959,0-1.944,0-2.903,0c0,0.24,0,0.48,0,0.72c-1.358,0-2.744,0-4.103,0
	c0-0.239,0-0.479,0-0.72c-5.009,0-10.017,0-14.999,0c0,0.293,0,0.613,0,0.906c0,0.053,0.053,0.053,0.106,0.053
	c4.316,0.48,8.658,0.986,12.975,1.439c3.543,0,7.113,0,10.656,0c0-0.56,0-1.119,0-1.705c-0.56,0-1.119,0-1.705,0
	C22.055,18.316,22.055,18.076,22.055,17.836z"
			/>
		</svg>
	);
}

export default RailSVG;
